import * as authActions from "./authActions";
import * as servicesActions from "./servicesActions";
import * as categoriesActions from "./categoriesActions";
import * as staffActions from "./staffActions";
import * as offerActions from "./offerActions";
import * as packagesActions from "./packagesActions";
import * as customersActions from "./customersActions";
import * as serviceProvidersActions from "./serviceProvidersActions";
import * as faqsActions from "./faqsActions";
import * as ticketManagementActions from "./ticketManagementActions";
import * as couponCodesActions from "./couponCodesActions";
import * as walletTransactionActions from "./walletTransactionActions";
import * as walletManagementActions from "./walletManagementActions";
import * as serviceProviderChatActions from "./serviceProviderChatActions";
import * as serviceProviderCustomersActions from "./serviceProviderCustomersActions";
import * as serviceProviderAppointmentsActions from "./serviceProviderAppointmentsActions";
import * as serviceProviderUserChatActions from "./serviceProviderUserChatActions";
import * as serviceProviderSubscriptionsActions from "./serviceProviderSubscriptionsActions";
import * as serviceProviderDashboardActions from "./serviceProviderDashboardActions";
import * as reviewsActions from "./reviewsActions";
import * as paymentActions from "./paymentActions";
import * as walletInfoActions from "./walletInfoActions";
import * as commonActions from "./commonActions";
import * as appointmentsActions from "./appointmentsActions";
import * as chatAccessActions from "./chatAccessActions";
import * as superAdminDashboardActions from "./superAdminDashboardActions";
import * as superAdminSubscriptionActions from "./superAdminSubscriptionActions";
import * as subscriptionPlanActions from "./subscriptionPlanActions";
import * as payrollActions from "./payrollActions";
import * as chatConversationActions from "./chatConversationActions";
import * as flashMessageActions from "./flashMessageActions";
import * as addonAndSponsorshipActions from "./addonAndSponsorshipActions";
import * as giftCardActions from "./giftCardActions";
import * as organizationSponsorshipActions from "./organizationSponsorshipActions";
import * as superAdminServicesActions from "./superAdminServicesActions";
import * as pushNotificationActions from "./pushNotificationActions";
import * as createAction from "./createAction";
import keyMirror from "keymirror";

//Add all the actions here in actions object const to mirror actions
const actions = keyMirror({
  ...authActions,
  ...servicesActions,
  ...categoriesActions,
  ...staffActions,
  ...offerActions,
  ...packagesActions,
  ...serviceProvidersActions,
  ...faqsActions,
  ...ticketManagementActions,
  ...customersActions,
  ...couponCodesActions,
  ...walletTransactionActions,
  ...walletManagementActions,
  ...serviceProviderChatActions,
  ...serviceProviderCustomersActions,
  ...serviceProviderAppointmentsActions,
  ...serviceProviderUserChatActions,
  ...serviceProviderSubscriptionsActions,
  ...serviceProviderDashboardActions,
  ...reviewsActions,
  ...paymentActions,
  ...walletInfoActions,
  ...commonActions,
  ...appointmentsActions,
  ...chatAccessActions,
  ...superAdminDashboardActions,
  ...superAdminSubscriptionActions,
  ...subscriptionPlanActions,
  ...payrollActions,
  ...chatConversationActions,
  ...flashMessageActions,
  ...addonAndSponsorshipActions,
  ...giftCardActions,
  ...organizationSponsorshipActions,
  ...superAdminServicesActions,
  ...pushNotificationActions
});

//Exporting all the actions from folder
const Actions = {
  ...createAction,
  ...actions,
};
export default Actions;
